<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ProductDetails from '~/components/product-details'

export default {
  name: 'ProviderProductDetails',
  components: {
    ProductDetails,
  },
  props: {
    providerProductId: {
      type: String,
      default: '',
    },
    providerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      supplierProductName: null,
    }
  },
  computed: {
    ...mapState('providerProduct', ['product']),
    ...mapState('providers', ['provider']),
    ...mapGetters('me', [
      'canUpdateProviderProduct',
      'canDeleteProviderProduct',
    ]),
    title() {
      return ('Product Name ' + this.product && this.product.name) || 'Provider Product'
    },
    commands() {
      const commands = []

      if (this.canUpdateProviderProduct) {
        commands.push({
          name: 'edit',
          label: 'Edit Provider Product',
        })
      }

      if (this.canDeleteProviderProduct) {
        commands.push({
          name: 'delete',
          label: 'Delete Provider Product',
        })
      }

      return commands
    },
  },
  created() {
    this.getData()
    this.getProvider(this.providerId)
  },
  methods: {
    ...mapActions('supplierProduct', ['getSupplierProduct']),
    ...mapActions('providerProduct', ['getProviderProduct']),
    ...mapActions('providers', ['getProvider']),
    async getData() {
      const { providerProductId, providerId } = this

      this.loading = true

      const [error, providerProduct] = await this.getProviderProduct({ providerProductId, providerId })

      if (error) {
        this.getErrorMessage(error, 'Provider Product', 'ID', this.providerProductId)
      } else {
        const [error, response] = await this.getSupplierProduct({
          supplierId: providerProduct.supplier_id,
          sku: providerProduct.supplier_product_sku,
        })

        if (!error) {
          this.supplierProductName = response.name
        }
      }

      this.loading = false
    },
    onMenuSelect(name) {
      this.$refs.details.onMenuSelect(name)
    },
  },
}
</script>

<template>
  <main-layout
    :title="title"
    :loading="loading"
    :back="{ name: 'provider-products' }"
    :error-message="errorMessageText"
  >
    <el-dropdown
      v-if="commands.length && !errorMessageText"
      slot="header"
      trigger="click"
      @command="onMenuSelect"
    >
      <dropdown-icon />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(command, index) in commands"
          :key="index"
          :command="command.name"
        >
          {{ command.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <product-details
      ref="details"
      :provider-id="providerId"
      :provider-product-id="providerProductId"
      :provider="provider"
      :product="{ ...product, supplier_product_name: supplierProductName }"
      :loading="loading"
      type="provider"
    />
  </main-layout>
</template>
